var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194,
    height: 172,
    viewBox: "0 0 194 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 172,
    transform: "translate(0.897 -0.07)",
    fill: "none",
    stroke: "#03542c",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1219 -5634)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(1324 5761)",
    fill: "#03542c",
    fontSize: 36,
    fontFamily: "Lato-Black, Lato",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.533,
    y: 0
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 26,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, "%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.481,132.108l5.926-20.908H134.333L160.266,81l-5.084,20.908h14.073Z",
    transform: "translate(1164.167 5601.371)",
    fill: "#8dc63f",
    stroke: "#8dc63f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1218.103 5645.07)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.725,182.894a60.886,60.886,0,0,1-20.169-45.339H53.764L37.486,105,9,137.556H21.208a81.391,81.391,0,0,0,143.918,52.1",
    transform: "translate(-4.622 -51.758)",
    fill: "none",
    stroke: "#03542c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.267,45.05a60.886,60.886,0,0,1,20.169,45.339H181.228l16.278,32.556,28.486-32.556H213.784A81.391,81.391,0,0,0,69.648,38.549",
    transform: "translate(-34.42 -4.591)",
    fill: "none",
    stroke: "#03542c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.147d93fd3087ec9e68103dd6717f83d2.svg";
export { ForwardRef as ReactComponent };